<template>
    <main class="flex flex-align flex-center">
        <spinner />
    </main>
</template>

<script>
    import Cookies from 'js-cookie';

    const publishers = {
        // 60011900374304: 'localhost', // Chairseven
        2500192111: 'https://digital.empoweringwriters.com',
        600016620787: 'https://digital.sharonwells.com',
        600001461712: 'https://digital.healthworldeducation.org',
    };

    export default {
        name: 'Assignment',
        created(){
            //For now, assignments are still hosted on the standard Cosmos portal.
            //We should basically just figure out which publisher we're dealing with, and then just redirect there.
            if(this.$store.getters.publisher){
                const base = publishers[this.$store.getters.publisher.id];

                if(base){
                    const oauth = Cookies.get('oauth');

                    if(oauth){
                        window.location.href = `${base}/launch/${oauth}/${this.$route.params.assignment}`;
                    }else{
                        window.location.href = `${base}/learn/${this.$route.params.assignment}`;
                    }
                }
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    main
    {
        width: 100vw;
        min-height: 100vh;
    }
</style>